import { Box } from "@mui/material";
import { isNil } from "lodash";
import React from "react";

import { useCropRotationContext } from "../../contexts/CropRotation.context";
import { CropRotation, Lot } from "../../types";
import CropRotationBlock from "./CropRotationBlock";

export default function CropRotationGroup({
  cropRotations,
  lot,
}: {
  cropRotations: CropRotation[] | CropRotation;
  lot: Lot;
}) {
  const { cropWidth, lotHeights, setLotHeight } = useCropRotationContext();
  const ref = React.createRef();
  const [height, setHeight] = React.useState<number>(0);

  React.useEffect(() => {
    if (ref.current) {
      const { current } = ref;
      // @ts-ignore
      const boundingRect = current.getBoundingClientRect();
      const { width, height } = boundingRect;
      setHeight(height);
      if (
        lotHeights &&
        (isNil(lotHeights[lot.id]) ||
          (!isNil(lotHeights[lot.id]) && lotHeights[lot.id] < height))
      ) {
        // console.log("setLotHeight", lot.ranch.name, lot.num, height);
        setLotHeight && setLotHeight({ lotId: lot.id, height });
      }
    }
  }, [ref]);

  if (cropRotations instanceof Array) {
    return (
      <Box
        ref={ref}
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          gap: "0.25rem",
        }}
      >
        {cropRotations.map((obj, i) => (
          <CropRotationBlock key={obj.id} cropRotation={obj} lot={lot} />
        ))}
      </Box>
    );
  }
  return (
    <Box ref={ref}>
      <CropRotationBlock cropRotation={cropRotations} lot={lot} />
    </Box>
  );
}
